import { ViewModel } from '../view-model';

export class DisciplineRequirement implements ViewModel {
  friendlyTypeNameSingular: string = 'Discipline Requirement';
  apiRoute: string;

  id: string;
  title: string;
  description: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
  }
}
